import { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { getToken, getRank, getSection } from './Common';
import { AuthContext } from "./AuthContext";

const PrivateRoute = ({ component: Component, restrictedToUpholstery, ...rest }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const token = getToken();
  const userSection = getSection();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!token) {
          // Redirect to login if not authenticated
          return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />;
        }
        if (restrictedToUpholstery) {
          // If restricted to upholstery, allow only if section is 'upholstery'
          // If not restricted to upholstery, deny access to 'upholstery' users
          if (userSection === '"Upholstery"') {
            return <Redirect to={{ pathname: "/Woodshop_Dashboard", state: { from: props.location } }} />;
          }
        }
        // Grant access if all conditions are satisfied
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;

